module.exports = __webpack_public_path__ + "static/Berber Block 2-59bd5c17a0bac04fed7a79028ffad945.png";